module.exports = __webpack_public_path__ + "img/b9_text.912c3ee7.png";